export default [
    {
      path: "/privilege/list",
      name: "privilege-list",
      component: () => import("@/views/pages/privilege/privilege-list/PrivilegeList.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Privilege Management',
        },
        {
          text: 'Privilege',
          active: true,
        },
      ],
    },
    {
      path: "/privilege/create",
      name: "privilege-create",
      component: () => import("@/views/pages/privilege/privilege-info/PrivilegeInfo.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Privilege Management',
        },
        {
          text: 'Privilege',
          active: true,
        },
        {
          text: 'Add Privilege',
          active: true,
        },
      ],
    },
    {
      path: "/privilege/info/:ref",
      name: "privilege-info",
      component: () => import("@/views/pages/privilege/privilege-info/PrivilegeInfo.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Privilege Management',
        },
        {
          text: 'Privilege',
          active: true,
        },
        {
          text: 'Edit Privilege',
          active: true,
        },
      ],
    },
    {
      path: "/privilege/category",
      name: "privilege-category",
      component: () => import("@/views/pages/privilege/privilege-category/PrivilegeCategory.vue"),
      meta: {
  
      },
      breadcrumb: [
        {
          text: 'Privilege Management',
        },
        {
          text: 'Category',
          active: true,
        },
      ],
    },
    {
      path: "/privilege/category/create",
      name: "privilege-category-create",
      component: () => import("@/views/pages/privilege/privilege-category-info/PrivilegeCategoryInfo.vue"),
      meta: {
  
      },
      breadcrumb: [
        {
          text: 'Privilege Management',
        },
        {
          text: 'Category',
          active: true,
        },
        {
          text: 'Add Category',
          active: true,
        },
      ],
    },
    {
      path: "/privilege/category/info/:ref",
      name: "privilege-category-info",
      component: () => import("@/views/pages/privilege/privilege-category-info/PrivilegeCategoryInfo.vue"),
      meta: {
  
      },
      breadcrumb: [
        {
          text: 'Privilege Management',
        },
        {
          text: 'Category',
          active: true,
        },
        {
          text: 'Edit Category',
          active: true,
        },
      ],
    },
    {
      path: "/privilege/report",
      name: "privilege-report",
      component: () => import("@/views/pages/privilege/privilege-report/PrivilegeReport.vue"),
      meta: {
  
      },
    },
    {
      path: "/privilege/history/:ref",
      name: "privilege-history",
      component: () => import("@/views/pages/privilege/privilege-history/PrivilegeHistoryList.vue"),
      meta: {
  
      },
      breadcrumb: [
        {
          text: 'Privilege Management',
        },
        {
          text: 'Privilege List'
        },
        {
          text: 'History',
          active: true,
        },
      ],
    },
    {
      path: "/privilege/code-template/list",
      name: "privilege-code-template-list",
      component: () => import("@/views/pages/privilege/privilege-code-template/code-template-list/CodeTemplateList.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Privilege',
        },
        {
          text: 'Code Template',
          active: true,
        },
      ],
    },
    {
      path: "/privilege/code-template/info/:ref",
      name: "privilege-code-template-info",
      component: () => import("@/views/pages/privilege/privilege-code-template/code-template-info/CodeTemplateInfo.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Privilege',
        },
        {
          text: 'Code Template',
          active: true,
        },
      ],
    },
    {
      path: "/privilege/code-template/create",
      name: "privilege-code-template-create",
      component: () => import("@/views/pages/privilege/privilege-code-template/code-template-info/CodeTemplateInfo.vue"),
      meta: {
  
      },
      breadcrumb: [
        {
          text: 'Privilege',
        },
        {
          text: 'Code Template',
          active: true,
        },
      ],
    },
  ];
  